/**
 * External Dependencies
 */
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight, faAngleLeft, faCircle , faShareAlt, faSearch, faGlobe, faCheck, faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faTimes, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faTwitterSquare, faYoutubeSquare, faLinkedin, faInstagramSquare } from '@fortawesome/free-brands-svg-icons';

import 'jquery';

import 'bootstrap';

import 'jquery-match-height';

import 'slick-carousel/slick/slick.min.js';

import Masonry from 'masonry-layout';

library.add(faAngleRight, faAngleLeft, faFacebookSquare, faYoutubeSquare, faTwitterSquare, faLinkedin, faInstagramSquare, faCircle, faShareAlt, faSearch, faGlobe, faCheck, faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faTimes, faPhone, faEnvelope);
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

$(document).ready(() => {
  if ($(window).width() > 769) {
    $('.dropdown > a').click(function() {
      location.href = $(this).data('href');
    });
  }

  $('.modal').click(function(event){
    $(event.target).modal('hide');
  });

  $('.card-swiper').slick({
    // dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 2,
    // slidesToScroll: 2,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.testimonial-swiper').slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    // slidesToScroll: 2,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.news-slider .card-body').matchHeight()

  $('.grid').each(function () {
    new Masonry('#'+this.id, {
      itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
      columnWidth: '.grid-sizer',
      percentPosition: false,
    });
  });

  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});
